import {
  createFetchApiClient,
  DEFAULT_API_TIMEOUT_MS,
  getApiClientErrorInfo,
} from '@nly/api-client'

const WECOM_SYNC_API_TIMEOUT_MS = 15 * 60 * 1000
const apiUrl = false
  ? new URL('/proxy/app', globalThis.location.origin)
  : new URL(
      '/app',
      new URL('https://api-test.nly.life' || '/', globalThis.location.origin),
    )

const apiClientOptions = {
  url: apiUrl,
  credentials: 'include' as const,
  headers: () => ({
    'Accept-Language': useAppSettingsStore().lang,
  }),
  onUnauthorized: () => useAppAccountStore().requestLogout(),
  onError: (error: unknown) => {
    const info = getApiClientErrorInfo(error)
    const description = [
      info.message,
      info.detail,
      info.requestId ? `(Request ID: ${info.requestId})` : undefined,
    ].filter(Boolean).join(' ')
    useKLToast().error('Error', { description })
  },
}

export const apiClient = createFetchApiClient({
  ...apiClientOptions,
  timeoutMs: DEFAULT_API_TIMEOUT_MS,
})

export const patientImportStreamUrl = new URL(`${apiUrl.pathname}/patientImport/recognize/stream`, apiUrl.origin)

// Login owns its error presentation inside the QR area; other requests keep global toasts.
export const weComLoginApi = createFetchApiClient({
  ...apiClientOptions,
  timeoutMs: DEFAULT_API_TIMEOUT_MS,
  onError: undefined,
}).account.wecomLogin

export const weComSyncApiClient = createFetchApiClient({
  ...apiClientOptions,
  timeoutMs: WECOM_SYNC_API_TIMEOUT_MS,
})
